import React, {useEffect, useState, useContext} from "react";
import AxiosConfig from "../../../../../../../frontend/gui/src/axiosConfig";
import "../CSS Files/tooglebar.css";
import {CreationContext} from "../../../../containers/Content/CreationSuite";
import { fabric } from 'fabric';

export function LoadFonts ()  {

        const {value} = useContext(CreationContext);
        const [creationCanvas, setCreationCanvas]= value;
        const [fontData, setFontData] = useState ([]);
        const [selectedFont, setSelectedFont] = useState('');
        const [selectedFontType, setSelectedFontType] = useState('');


        const getHandWritingFontData =()=> {

            AxiosConfig.get('/creation_suite/text_font/' + 'H').then((res)=>
                setFontData(res.data.fonts))
        }

        const getFuturisticFontData =()=> {

            AxiosConfig.get('/creation_suite/text_font/' + 'F').then((res)=>
                setFontData(res.data.fonts))

        }

        const getFunFontData =()=> {

            AxiosConfig.get('/creation_suite/text_font/' + 'N').then((res)=>
                setFontData(res.data.fonts))

        }

        const getTypeWriterFontData =()=> {

            AxiosConfig.get('/creation_suite/text_font/' + 'T').then((res)=>
                setFontData(res.data.fonts))

        }

        const getStandardFontData =()=> {

            AxiosConfig.get('/creation_suite/text_font/' + 'S').then((res)=>
                setFontData(res.data.fonts))

        }

        useEffect(()=> {

            if (selectedFont) {
                let addText = new fabric.IText('Double click to type', {
                    fontSize: 30,
                })

                let tempString = JSON.stringify({selectedFont})
                let tempObj = JSON.parse(tempString);

                addText.set("fontFamily", tempObj.selectedFont.fontData.trim());
                creationCanvas.add(addText)

            } else {
                setSelectedFont(getStandardFontData)
            }

        },[selectedFont])

    return (

        <div className="text-toggle">
            <div id="handwriting-categories">
                <button id="standard-button"
                        onClick={getStandardFontData}>
                    Standard Styles
                </button>

                <button id = "handwriting-button"
                        onClick={getHandWritingFontData}>
                    Handwriting Styles
                </button>

                <button id = "futuristic-button"
                        onClick={getFuturisticFontData}>
                    Futuristic Styles
                </button>

                <button id = "typewriting-button"
                        onClick={getTypeWriterFontData}>
                    Typewriting Styles
                </button>

                <button id = "fun-button"
                    onClick={getFunFontData}>
                    Fun Styles
                </button>
            </div>

            <div id= "font-container">
                {fontData ? fontData.map((fontData, i) =>
                    <button key={i}
                            style={{fontFamily: fontData}}
                            onClick={() => setSelectedFont({fontData})}>
                        {fontData}
                    </button>) : null
                }
            </div>

        </div>

    )
}



